module.exports = __webpack_public_path__ + "img/clearfix.b0c60898.png";